<template>
  <!-- 会议折线统计图 -->
  <div class="meeting_Stat" id="meeting_echarts"></div>
</template>

<script>
const echarts = require("echarts");
var t = null
export default {
  name: "MeetingChart",
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    MeetingStat: {
      type: Object,
      default: {},
    },
  },
  created() {
    const that = this
    window.addEventListener("resize", function () {
      if (that.delay) {
        clearTimeout(that.delay);
      }
      that.delay = setTimeout(function () {
        // console.log(that.MeetingStat)
        that.initmeeting_echarts(that.MeetingStat);
      }, 20);
    });
  },
  watch: {
    "MeetingStat": function (val) {
      this.initmeeting_echarts(val)
    },
  },
  methods: {
    resizeWindow() {

    },
    initmeeting_echarts(options) {
      // console.log(options)
      for (const i in options.series) {
        options.series[i].type = "line"
      }
      if(!document.getElementById("meeting_echarts")) return
      var myChart = echarts.init(document.getElementById("meeting_echarts"));
      myChart.resize()
      var that = this;
      myChart.setOption({
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          data: options.xAxis,
        },
        legend: {
          orient: "horizontal",
          left: 60,
          top: 0,
          textStyle: {
            //图例文字的样式
            fontSize: 12,
          },
          data: options.legend,
        },
        grid: {
          containLabel: false,
          width: "90%",
          height: "70%",
          left: "center",
          y2: 20,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        yAxis: {
          type: "value",
        },
        series: options.series,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.meeting_Stat {
  height: calc(~"100vh - 515px");
}
</style>



// WEBPACK FOOTER //
// src/components/Echarts/index.vue